<template>
  <div class="">
    <br />
    <br />
    <!-- Search Section -->
    <div class="searchSection">
      <input
        class="search-input form-control"
        type="text"
        name="search"
        v-model="search"
        :placeholder="placeholder"
      />
      <button
        @click="Search()"
        class="search-btn shadow border text-white primary form-control"
      >
        Search
      </button>
      <p class="text-left results mt-2">results: {{ projects.length }}</p>
    </div>
    <!--<br />-->
    <!-- <br />-->
    <!-- Sppiner -->
    <div
      v-if="projectsDoesntLoaded"
      class="spinner-grow text-primary"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
    <!-- err alert -->
    <div v-if="errMsg" class="container">
      <div class="alert alert-danger">{{ errMsg }}</div>
    </div>
    <!-- Projects Will Goes Here -->
    <div
      v-for="project in projects"
      :key="project"
      class="text-left p-4 shadow  my-2 projectComponent"
    >
      <div class="row">
        <div class="col-md-6">
          <h4 class="project-title">
            <strong>{{ project.title }}</strong>
          </h4>
          <p class="text-dark created_at">
            <i class="far mr-2 fa-clock"></i>
            {{ project.created_at }}
          </p>
        </div>
        <div class="col-md-6">
          <h5 class="project-budget text-right">
            <strong>{{ project.budget }}</strong>
          </h5>
        </div>
      </div>
      <div
        style="font-weight:500!important;font-size:15px!important;"
        class="body"
      >
        {{ project.description }}
      </div>
      <!--<br />-->
      <div class="row">
        <div class="col-md-9">
          <p
            v-for="skill in project.skills"
            :key="skill"
            class="skills badge badge-dark mr-2"
          >
            {{ skill }}
          </p>
        </div>
        <div class="col-md-3">
          <router-link
            :to="'/project/' + project._id"
            class="primary shadow border text-white float-right btn btn-sm"
            >Details</router-link
          >
        </div>
      </div>
    </div>
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
import footerApp from "../components/footer.vue";

export default {
  name: "projects",

  components: {
    // HelloWorld
    footerApp
  },

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN

      placeholder: "software developer,video editor ...",

      search: null,

      projects: [],

      projectsDoesntLoaded: true,

      errMsg: null
    };
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    // auth stuff goes here...
    let projectsAfterProcess = [];
    if (!this.token) {
      this.$http({
        method: "get",
        url: link.baselink + "/project/get",
        // withCredentials: true,
        headers: {
          // 'Access-Control-Request-Headers':'access-token',
          // "Access-Control-Allow-Origin": "*",
          // "Access-Control-Allow-Credentials":"true",
          // 'access-token':this.token
        }
      })

        .then(function(res) {
          // PROCCESS DATA
          for (var i = 0; i < res.data.length; i++) {
            const project_data = {
              _id: res.data[i]._id,
              title: res.data[i].title,
              user_id: res.data[i].user_id,
              description: res.data[i].description.substring(0, 100) + "...",
              skills: res.data[i].skills.split(","),
              budget: res.data[i].budget,
              created_at: res.data[i].created_at
            };

            // PUSH DATA TO A LOCAL VARIABLE CUSE WE CANNOT USE THIS KEYWORD IN ARROW FUNCTIONS
            // OR CALLBACK AND WE ARE IN A CALLBACK FUNCTION RIGHT NOW <inside callback function .then()>
            projectsAfterProcess.push(project_data);
          }
        })
        .catch(function(err) {
          // Something Goes Here...
          // console.log(err);
          this.errMsg = err.message;

          alert(err.message);

          // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
          this.projectsDoesntLoaded = false;
        });

      // PUSH PROJECTS TO THE GLOBAL ARRAY <outside callback function .then()>
      this.projects = projectsAfterProcess;
      // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
      this.projectsDoesntLoaded = false;
    } else {
      // INIT AN LOCAL ARRAY THE CAUSE IS WE CANNOT USE this KEYWORD INNER ARROW  FUNCTIONS
      const projectsFromArray = [];

      this.$http({
        method: "get",
        url: link.baselink + "/project/get/pr/" + this.token
        // withCredentials: true,
      })

        .then(res => {
          // FOR EACH LOOP FOR COLLECT PROJECTS FROM ARRAY
          res.data.forEach(arrayOfProjects => {
            // FOR EACH LOOP FOR COLLECT PROJECT INSIDE OUR SUB ARRAY
            arrayOfProjects.forEach(project => {
              // HANDLE DATA
              const project_data = {
                _id: project._id,
                title: project.title,
                user_id: project.user_id,
                description: project.description.substring(0, 100) + "...",
                skills: project.skills.split(","),
                budget: project.budget,
                created_at: project.created_at
              };

              // PUSH PROJECT TO LOCAL ARRAY
              projectsFromArray.push(project_data);
            });
          });

          // console.log("it works!");

          // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
          this.projectsDoesntLoaded = false;
        })
        .catch(err => {
          // Something Goes Here...
          // console.log(err);
          alert(err.message);

          // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
          this.projectsDoesntLoaded = false;
        });
      this.projects = projectsFromArray;
    }
    // Fetch Data Stuff Over Here...
    // If User Loggged in /tokenRequired
    // If User Not Logged in /tokenNotRequired
  },
  methods: {
    Search: function() {
      // INIT LOCAL VARIABLE
      let projectsAfterProcess = [];

      if (this.search === null) {
        document.querySelector(".search-input").style.border = ".5px solid red";
      } else {
        document.querySelector(".search-btn").innerHTML = `
		<span class="spinner-grow spinner-grow-sm text-dark" role="status" aria-hidden="true"></span>`;

        // REMOVE PROJECT ARRAY ITEMS
        this.projects = null;

        // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
        this.projectsDoesntLoaded = true;

        // FETCH DATA FROM THE SERVER
        this.$http({
          url: link.baselink + `/project/search?projectBody=${this.search}`,
          method: "get",
          headers: {}
        })
          .then(res => {
            // PROCCESS DATA
            for (var i = 0; i < res.data.data.length; i++) {
              const project_data = {
                _id: res.data.data[i]._id,
                title: res.data.data[i].title,
                user_id: res.data.data[i].user_id,
                description:
                  res.data.data[i].description.substring(0, 100) + "...",
                skills: res.data.data[i].skills.split(","),
                budget: res.data.data[i].budget,
                created_at: res.data.data[i].created_at
              };
              // console.log(project_data)

              // PUSH DATA TO A LOCAL VARIABLE CUSE WE CANNOT USE THIS KEYWORD IN ARROW FUNCTIONS
              // OR CALLBACK AND WE ARE IN A CALLBACK FUNCTION RIGHT NOW <inside callback function .then()>
              projectsAfterProcess.push(project_data);
            }

            // PUSH SEARCHED PROJECT TO GLOBAL VARIABLE
            this.projects = projectsAfterProcess;
            document.querySelector(".search-btn").innerHTML = `Search`;

            // SET THE LOADING SPINNETR OFF BY SET THIS VARIABLE BELOW TO FALSE
            this.projectsDoesntLoaded = false;
          })
          .catch(err => {
            // Something Goes Here...
            // console.log(err);
            alert(err.message);
            document.querySelector(".search-btn").innerHTML = `Search`;
          });
      }
    }
  }
};
</script>

<style lang="css" scoped>
.main-title {
  font-size: 50px;
}
.select {
  width: 100px;
}
.search-input {
  /*width: 450px;*/
  width: 80%;
}
.search-btn {
  border: none;
  width: 20%;
}
.select,
.search-input,
.search-btn {
  display: inline;
  margin: 0px;
}
.projectComponent {
  color: var(--bg-color);
  width: 70%;
  margin: 0 auto;
  /*height: 150px;*/
  border-left: 5px solid var(--primary-color) !important;
  border-radius: 3px;
  /*border: .5px solid transparent;*/
}
.searchSection {
  width: 70%;
  margin: 0 auto;
}
.projectComponent:hover {
  border-left: 5px solid var(--bg-color-dark) !important;
  transition: all 0.2s !important;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 4px 18px 0 rgba(0, 0, 0, 0.19) !important;
  /*border: .5px solid var(--bg-color)!important;*/
}
.body {
  font-weight: 100;
  /*font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  font-size: 15px;
}
.skills {
  font-size: 10px;
}
.inline {
  display: inline !important;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.none {
  display: none;
}
.block {
  display: block;
}
.created_at {
  font-size: 12px;
  font-weight: 200;
}
.footerApp {
  margin-top: 100px;
}
.border {
/*  padding-left: 30px!important;
  padding-right: 30px!important;*/
  border-radius: 3px;
}
@media only screen and (max-width: 600px) {
  .searchSection {
    width: 100% !important;
  }
  .projectComponent {
    width: 90%;
    /*height: 150px;*/
  }
  .project-title {
    font-size: 25px !important;
  }
  .project-budget {
    float: left !important;
  }
  .skills {
    margin: 1px !important;
  }
  .main-title {
    font-size: 30px !important;
  }
  .landing-page {
    padding-top: 30%;
  }
  .search-input {
    width: 90% !important;
  }
  .search-btn {
    width: 90% !important;
  }
  .results {
    margin-left: 20px;
  }
}
</style>
